import { useEffect, useState } from 'react';

// Mirror in `crm.css` - the layout and the disclosure have to flip together.
export const WIDE_LAYOUT_QUERY = '(min-width: 1280px)';

export function useWideLayout() {
  const [wide, setWide] = useState(() => window.matchMedia(WIDE_LAYOUT_QUERY).matches);

  useEffect(() => {
    const query = window.matchMedia(WIDE_LAYOUT_QUERY);
    const onChange = (event) => setWide(event.matches);
    query.addEventListener('change', onChange);
    setWide(query.matches);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return wide;
}
